export default __webpack_public_path__ + "static/media/Circus_08.5b49e33a.png";